import { hasWindow } from "./hasWindow";

export function setCookie(
  name: string,
  value: string,
  options?: Record<string, unknown>
): void {
  if (hasWindow) {
    options = {
      path: "/",
      // при необходимости добавьте другие значения по умолчанию
      ...options,
    };

    if (options.expires instanceof Date) {
      options.expires = options.expires.toUTCString();
    }

    let updatedCookie =
      encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (const optionKey in options) {
      if (Object.prototype.hasOwnProperty.call(options, optionKey)) {
        updatedCookie += "; " + optionKey;
        const optionValue = options[optionKey];
        if (optionValue !== true) {
          updatedCookie += `=${optionValue as string}`;
        }
      }
    }

    document.cookie = updatedCookie;
  }

  return void 0;
}

export function getCookie(name: string) {
  if (hasWindow) {
    const cookieName = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
  }
  return undefined;
}

export function deleteCookie(
  name: string,
  domain?: string,
  path?: string
): void {
  if (hasWindow) {
    const date = new Date();

    // Set it expire in -1 days
    date.setTime(date.getTime() - 24 * 60 * 60 * 1000);

    let cookieString =
      name + "=; expires=" + date.toUTCString() + `; path=${path ?? "/"}`;
    document.cookie = cookieString;

    // If domain is provided, add it to the cookie string
    if (domain) {
      cookieString =
        name +
        "=; expires=" +
        date.toUTCString() +
        `; path=${path ?? "/"}; domain=` +
        domain;
      document.cookie = cookieString;
    }
  }
  return void 0;
}
